import { useState } from 'react';

import { EditIcon } from 'lucide-react';
import { proxy, useSnapshot } from 'valtio';

import { AlertDialog, AlertDialogContent } from '../../../ui/alert-dialog.jsx';
import { Button } from '../../../ui/button.jsx';
import { FormAccountActionNewPassword } from '../forms/form-account-action-new-password.jsx';
import { FormAccountActionValidateOtp } from '../forms/form-account-action-validate-otp.jsx';
import { FormAccountActionValidatePassword } from '../forms/form-account-action-validate-password.jsx';

export const dialogAccountUpdatePasswordState = proxy({
  step: 1,
});

export const DialogAccountUpdatePassword = () => {
  const { step } = useSnapshot(dialogAccountUpdatePasswordState);

  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="portal" onClick={() => setOpen(true)}>
        <EditIcon className="size-4" /> Alterar Palavra-passe
      </Button>

      <AlertDialog
        open={open}
        onOpenChange={(open) => {
          if (!open) {
            dialogAccountUpdatePasswordState.step = 1;
          }

          setOpen(open);
        }}
      >
        <AlertDialogContent>
          {step === 1 && (
            <FormAccountActionValidatePassword
              actionTitle="Editar Palavra-passe"
              onFormSuccess={() => {
                dialogAccountUpdatePasswordState.step = 2;
              }}
            />
          )}

          {step === 2 && (
            <FormAccountActionValidateOtp
              actionTitle="Editar Palavra-passe"
              verifyEndpoint="/auth/update-password/verify-otp"
              sendOtpEndpoint="/auth/update-password/otp"
              onFormSuccess={() => {
                dialogAccountUpdatePasswordState.step = 3;
              }}
            />
          )}
          {step === 3 && <FormAccountActionNewPassword />}
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
